import {
    centsToFormattedDollars,
    formattedDollarsToCents,
} from '@fruitful/fruitils';
import { type BillCategory, type BillingCadence } from '@fruitful/types';

import type { Bill } from '../../entities/entityTypes';
import { parseBillCategory } from './billCategoryDisplay';

export interface MoneyMapperBillTableDraft {
    displayName: string;
    payee: string;
    amountStr: string;
    cadence: BillingCadence;
    category: BillCategory;
}

const firstNonEmptyTrimmed = (
    ...values: Array<string | null | undefined>
): string => {
    for (const value of values) {
        const trimmed = value?.trim();
        if (trimmed != null && trimmed !== '') {
            return trimmed;
        }
    }
    return '';
};

export const billToMoneyMapperTableDraft = (
    bill: Bill,
): MoneyMapperBillTableDraft => ({
    displayName: firstNonEmptyTrimmed(bill.displayName, bill.name, bill.payee),
    payee: bill.payee?.trim() ?? '',
    amountStr: centsToFormattedDollars(bill.amount, true),
    cadence: bill.cadence,
    category: parseBillCategory(bill),
});

export const isMoneyMapperBillTableDraftUnchanged = (
    bill: Bill,
    d: MoneyMapperBillTableDraft,
): boolean => {
    const name = d.displayName.trim();
    const cents = formattedDollarsToCents(d.amountStr);
    if (!Number.isFinite(cents)) {
        return false;
    }
    return (
        firstNonEmptyTrimmed(bill.displayName, bill.name, bill.payee) ===
            name &&
        bill.amount === cents &&
        bill.cadence === d.cadence &&
        parseBillCategory(bill) === d.category &&
        (bill.payee?.trim() ?? '') === d.payee.trim()
    );
};
